export class retornoCamposGraficos {
    ValorOrdenacao: number=0;
    DadosQuadroGeral: string[] =[];
    constructor() {
    }
}